import axios from '../../../../utills/axiosConfig';

export const fetchPurities = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/purities', { params });
  return res.data;
};

export const addPurity = async (purity) => {
  try {
    const res = await axios.post('/purities', purity);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updatePurity = async (id, purity) => {
  const res = await axios.put(`/purities/${id}`, purity);
  return res.data;
};

export const deletePurity = async (id) => {
  const res = await axios.delete(`/purities/${id}`);
  return res.data;
};

export const importPurityCSV = async (formData) => {
  const { data } = await axios.post('/purities/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 